import axios from 'axios';

import { AssetsResult, GetEntityAssetsRequest, PrepareAssetRequest, PreparedAsset } from './types';

const assetRepositoryServiceApi = axios.create({
  baseURL: process.env.ASSET_REPOSITORY_SERVICE_URI,
});

export default assetRepositoryServiceApi;

export const prepareAssets = (params: PrepareAssetRequest) =>
  assetRepositoryServiceApi.post<PreparedAsset[]>('/v1/assets', params).then(response => response.data);

export const getEntityAssets = ({
  source,
  sourceId,
  scope,
  scopeId,
  size,
  cursor,
}: GetEntityAssetsRequest): Promise<AssetsResult> =>
  assetRepositoryServiceApi
    .get('/v1/assets', { params: { source, sourceId, scope, scopeId, size, cursor } })
    .then(response => response.data);

export const archiveAssets = (assetIds: string[]) =>
  assetRepositoryServiceApi.delete(`/v1/assets?id=${assetIds.join('&id=')}`);
